import { z } from 'zod'
import { companyRole } from '../company/company-role'

export const clientCampaign = z.object({
    id: z.string(),
    title: z.string(),
})

export const client = z.object({
    userId: z.string(),
    companyId: z.string(),
    role: companyRole,
    name: z.string().optional(),
    email: z.string().optional(),
    avatar: z.string().optional(),
    assignedCampaigns: clientCampaign.array().default([]),
})

export type Client = z.infer<typeof client>
export type ClientCampaign = z.infer<typeof clientCampaign>

export const inviteClientInput = z.object({
    emails: z.string().array(),
    campaignIds: z.string().array().default([]),
})

export type InviteClientInput = z.infer<typeof inviteClientInput>
